// extracted by mini-css-extract-plugin
module.exports = {"container":"CertDest_container__YVs2C","textContainer":"CertDest_textContainer__IftjZ","logoContainer":"CertDest_logoContainer__OKu5o","icon":"CertDest_icon__eeimA"};